import { useState, useCallback } from "react";

export function useRowHover<TId>():
	[uniqueKey: TId | undefined, hoverHandler: (id: TId, isHover: boolean) => void] {
		const [hoveredRowId, setHoveredRowId] = useState<TId | undefined>(undefined);

		const hoverHandler = useCallback(
			(id: TId, isHover: boolean): void => {
				setHoveredRowId(isHover ? id : undefined);
			},
			[]
		);

		return [hoveredRowId, hoverHandler];
};